import { useAtomValue } from 'jotai';
import React from 'react';
import { userAtom } from '../atoms/userAtom';
import { Button, Stack } from '@mui/material';

export type TabType = 'all' | 'startlist' | 'users';

class Props {
    sel: TabType;
    onItemSelected: (sel: TabType) => void;
}

const Menu = (props: Props) => {
     const user = useAtomValue(userAtom);

    return <Stack spacing={2} direction={"row"}>
        <Button variant={ props.sel == 'all' ? "contained" : "text"} onClick={() => {props.onItemSelected('all')}}>All athletes</Button>
        <Button variant={ props.sel == 'startlist' ? "contained" : "text"} onClick={() => {props.onItemSelected('startlist')}}>Startlist</Button>
        {user.role == 'admin' && <Button variant={ props.sel == 'users' ? "contained" : "text"} onClick={() => {props.onItemSelected('users')}}>Users</Button>}
    </Stack>
}

export default Menu;